import { gql } from '@apollo/client';

import { Academy } from '../../types';
import { academyFragment } from '../fragments';

export interface GetAcademyQueryResult {
  academy: Academy;
}

export const getAcademyQuery = gql`
  query GetAcademyQuery {
    academy @rest(type: "Academy", path: "academy") {
      ...Academy
    }
  }
  ${academyFragment}
`;
